/**
 * Created by mukund on 7/24/17.
 */

angular.module('mediacloudApp')
    .directive('captionManagement', ['$rootScope', '$state', '$timeout', '$filter', 'CollectionService', 'BaseFileService', 'BatchService', 'UploadErrors', 'SearchService', 'SchedulerService', function($rootScope, $state, $timeout, $filter, CollectionService, BaseFileService, BatchService, UploadErrors, SearchService, SchedulerService) {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/caption-management/caption-management.html',
            scope: {
                render: '=',
                renderSource: '=',
                content: '=',
                account: '=',
            },
            link: function (scope, element, attrs) {

                if (scope.account) {
                    scope.closeFolderSelectionModal = function () {
                        scope.selectedFolder = null;
                        $('#captionManagementWindow').modal('hide');
                    };

                    scope.checkDisabled = true;

                    scope.handleModalBtnKeyDown = function(e) {
                        if(e.which === 9 && !e.shiftKey) {
                            var closeBtn = document.querySelector('#captionManagementWindow .modal-dialog .btn-blank.btn-close');
                            closeBtn.focus();
                        }
                    }

                    var languages = [{
                        id: 1,
                        title: 'English'
                    },
                    {
                        id: 2,
                        title: 'Spanish'
                    },
                    {
                        id: 3,
                        title: 'French'
                    },
                    {
                        id: 4,
                        title: 'German'
                    },
                    {
                        id: 5,
                        title: 'Portuguese'
                    },
                    ];

                    scope.handleSearchInputKeyUp = function (e) {
                        scope.filteredLanguages = languages.filter(p => p.title.toLowerCase().startsWith(e.target.value.toLowerCase()));
                        $('#languageSearchResults').show();

                        if(scope.filteredLanguages.length) {
                            $('#languageNoResults').hide();
                        } else {
                            $('#languageNoResults').show();
                        }
                    }

                    scope.handleResultClick = function(e) {
                        var searchInput = $('#captionManagementWindow').find('input');
                        var languageId = $(e.target).parent().attr('data-language-id');
                        var selectedLanguage = languages.filter(p => p.id.toString() === languageId.toString());
                        $(searchInput).val(selectedLanguage[0].title);
                        $('#languageSearchResults').hide();
                    }

                    scope.handleSearchCancelClick = function(e) {
                        var searchInput = $('#captionManagementWindow').find('input');
                        $(searchInput).val('');
                        $(searchInput).focus();
                        $('#languageNoResults').hide();
                        $('#languageSearchResults').show();
                    }

                    scope.handleSearchInputFocus = function(e) {
                        scope.filteredLanguages = languages;
                        $('#languageSearchResults').show();
                    }

                    scope.handleSearchInputBlur = function(e) {
                        setTimeout(() => {
                            $('#languageSearchResults').hide();
                        }, 200)
                    }
                }
            }
        }
    }]);
